import { easings } from "../../../../../../config";
import { css } from "@linaria/core";

export const lineCls = css`
  position: absolute;
  top: 50%;
  right: 0;
  background-color: inherit;
  transition: transform 150ms ${easings.inOutCubic};

  &.upper {
    transform: translateY(-50%) rotate(45deg) scaleY(0.5);
    transform-origin: right center;
  }

  &.lower {
    transform: translateY(-50%) rotate(-45deg) scaleY(0.5);
    transform-origin: right center;
  }
`;

export const chevronCls = css`
  display: inline-block;
  position: relative;
  color: inherit;

  &.vertical {
    transform: rotate(90deg);
  }

  /* translate lines -70.710% to align with the left edge of the container
   * (value based on the Pythagorean theorem) and rotate the direction of the
   * chevron by additional 90deg */
  &.inversed .${lineCls} {
    transform: translateY(-50%) translateX(-70.71%) rotate(135deg) scaleY(0.5);
  }

  &.inversed .${lineCls}.lower {
    transform: translateY(-50%) translateX(-70.71%) rotate(-135deg) scaleY(0.5);
  }
`;
